import React from "react";

type Year = number;

type UseYtdDataProps<TData> = {
  isLoading: boolean;
  data?: {
    yearsAvailable: Year[];
    years: Record<Year, TData>;
  };
};

export const useYtdData = <TData>(props: UseYtdDataProps<TData>) => {
  const { data, isLoading } = props;
  const [selectedYear, setSelectedYear] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (data?.yearsAvailable && data.yearsAvailable.length > 0 && !selectedYear) {
      const mostRecentYear = Math.max(...data.yearsAvailable);

      setSelectedYear(mostRecentYear.toString());
    }
  }, [data?.yearsAvailable, selectedYear]);

  const yearData = React.useMemo(() => {
    if (!data?.years || !selectedYear) return null;

    return data.years[Number(selectedYear)];
  }, [data?.years, selectedYear]);

  const yearOptions = React.useMemo(
    () =>
      (data?.yearsAvailable || []).map((year) => ({
        value: year.toString(),
        label: year.toString(),
      })),
    [data?.yearsAvailable]
  );

  return {
    yearData,
    selectProps: {
      disabled: isLoading || yearOptions.length < 1,
      placeholder: "Year",
      data: yearOptions,
      value: selectedYear,
      onChange: setSelectedYear,
    },
  };
};
